import React, { useState, useEffect, useRef } from 'react';
import confetti from 'canvas-confetti';
import './App.css';

// --- ICONS (SVG LINE ART) ---
const DownloadIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>);
const PauseIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect></svg>);
const SettingsIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>);
const PartyIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 13.5v3.917a.583.583 0 0 1-.583.583H2.583a.583.583 0 0 1-.583-.583v-3.917C2 7.5 7.5 3 12 3s10 4.5 10 10.5z"/><path d="M12 3v5"/><path d="M8 6.5l-2-2"/><path d="M16 6.5l2-2"/></svg>);
const ThumbUpIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path></svg>);
const ThumbDownIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path></svg>);
const RocketIcon = () => <span className="rocket-anim">🚀</span>;
const FullscreenIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path></svg>);
const SortIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 6h18M3 12h18M3 18h18"></path></svg>);
const ListIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>);
const TrashIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>);
const CloseIcon = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>);
const PlusIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>);
const MinusIcon = () => (<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line></svg>);

// --- ROULETTE ICON ---
const RouletteIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
    <path d="M2 12h20"></path>
  </svg>
);

// --- ROULETTE POPUP COMPONENT ---
const RoulettePopup = ({ onClose }) => {
  const [rotation, setRotation] = useState(0);
  const [result, setResult] = useState("DRAAI");
  const [isSpinning, setIsSpinning] = useState(false);
  // Spin geschiedenis en cooldown variabele verwijderd

  const spinWheel = () => {
    // Geen check meer op tijd of aantal spins. Gewoon draaien.
    setIsSpinning(true);
    setResult("...");

    const randomSpin = Math.floor(Math.random() * 360);
    const totalRotation = rotation + 1800 + randomSpin; 
    setRotation(totalRotation);

    setTimeout(() => {
      const actualDegree = totalRotation % 360;
      if (actualDegree < 90) setResult("ROOD");
      else if (actualDegree < 180) setResult("ZWART");
      else if (actualDegree < 270) setResult("ROOD");
      else setResult("ZWART");
      setIsSpinning(false);
    }, 4000);
  };

  return (
    <div className="roulette-overlay">
      <div className="roulette-modal glass-panel">
        <button className="close-btn" onClick={onClose}><CloseIcon /></button>
        <h2 className="roulette-result" style={{ 
          color: result === "ROOD" ? "#ef5350" : (result === "ZWART" ? "#37474f" : "#212121") 
        }}>{result}</h2>
        <div className="wheel-wrapper">
          <div className="roulette-pointer"></div>
          <div className="roulette-wheel" style={{ transform: `rotate(-${rotation}deg)` }}></div>
        </div>
        <button className="gold-btn" onClick={spinWheel} disabled={isSpinning}>
          {isSpinning ? "DRAAIT..." : "DRAAI NU"}
        </button>
      </div>
    </div>
  );
};

// --- APP ---
const TOTAL_ROUNDS = 15;
const formatCurrency = (amount) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(amount);

function App() {
  // ==========================================
  // --- CONFIGURATIE ---
  // ==========================================
  const ENABLE_FULL_SETUP   = true;  
  const ENABLE_GAME_TOOLS   = false; 
  const SHOW_BG_IMAGE       = false; 
  const ENABLE_AUTOSAVE     = true; 
  
  const ENABLE_SECURITY     = false;
  const ENABLE_AUDIO        = false;
  const ENABLE_CONFETTI     = false;
  const ENABLE_KIOSK        = false;
  const ENABLE_PAUSE        = false;
  
  // AANGEPASTE KLEURENLIJST
  const DEMO_COLORS = [
    '#FF0000', // Rood
    '#0000FF', // Blauw
    '#008000', // Groen
    '#ffbf00', // Geel
    '#ff6600', // Oranje
    '#800080', // Paars 
    '#008080', // Blauwgroen
    '#808080'  // Grijs
  ];

  const allowedHost = 'decrimegame.nl'; 
  const GAME_PASSWORD = 'MichaelCrimineel2024';
  // ==========================================

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [inputPassword, setInputPassword] = useState('');
  const [showRoulette, setShowRoulette] = useState(false);

  const [setupMode, setSetupMode] = useState(() => {
    if (!ENABLE_AUTOSAVE) return true;
    const saved = localStorage.getItem('crimeGameSetup');
    return saved !== null ? JSON.parse(saved) : true;
  });

  const [numGroups, setNumGroups] = useState(() => {
    if (!ENABLE_AUTOSAVE) return 4; 
    const saved = localStorage.getItem('crimeGameNumGroups');
    return saved ? JSON.parse(saved) : 4;
  });

  const [groups, setGroups] = useState(() => {
    if (!ENABLE_AUTOSAVE) return [];
    const saved = localStorage.getItem('crimeGameGroups');
    return saved ? JSON.parse(saved) : [];
  });

  const [currentRound, setCurrentRound] = useState(() => {
    if (!ENABLE_AUTOSAVE) return 1;
    const saved = localStorage.getItem('crimeGameRound');
    return saved ? JSON.parse(saved) : 1;
  });

  const [theme, setTheme] = useState('light');
  const [customBg, setCustomBg] = useState('#2c3e50');
  const [bgImageOpacity, setBgImageOpacity] = useState(0.5);
  const [cardOpacity, setCardOpacity] = useState(0.85);

  const [isPaused, setIsPaused] = useState(false);
  const elevatorAudioRef = useRef(new Audio('/elevator.mp3'));

  const isDevelopment = process.env.NODE_ENV === 'development';
  const currentHost = window.location.hostname.replace('www.', '');
  const isBlocked = ENABLE_SECURITY && !isDevelopment && currentHost !== allowedHost;

  useEffect(() => {
    if (!ENABLE_AUTOSAVE) return;
    localStorage.setItem('crimeGameSetup', JSON.stringify(setupMode));
    localStorage.setItem('crimeGameNumGroups', JSON.stringify(numGroups));
    localStorage.setItem('crimeGameGroups', JSON.stringify(groups));
    localStorage.setItem('crimeGameRound', JSON.stringify(currentRound));
    localStorage.setItem('crimeGameTheme', theme);
  }, [setupMode, numGroups, groups, currentRound, theme, ENABLE_AUTOSAVE]);

  // Initialisatie bij eerste keer laden
  useEffect(() => {
    if (groups.length === 0 && setupMode) {
      const newGroups = Array.from({ length: 4 }, (_, i) => ({
        id: i + 1, name: `Groep ${i + 1}`, color: DEMO_COLORS[i] || '#333', scores: {}, 
      }));
      setGroups(newGroups);
      setNumGroups(4);
    }
  }, [setupMode, groups.length]);

  useEffect(() => { document.documentElement.style.setProperty('--card-opacity', cardOpacity); }, [cardOpacity]);
  useEffect(() => { document.body.style.backgroundColor = customBg; }, [customBg]);

  useEffect(() => {
    if (!ENABLE_AUDIO) return;
    const audio = elevatorAudioRef.current;
    audio.loop = true; 
    if (isPaused) { audio.play().catch(() => {}); } 
    else { audio.pause(); audio.currentTime = 0; }
  }, [isPaused, ENABLE_AUDIO]);

  useEffect(() => {
    if (!ENABLE_KIOSK) return;
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener('contextmenu', handleContextMenu);
    return () => document.removeEventListener('contextmenu', handleContextMenu);
  }, [ENABLE_KIOSK]);

  const handleLogin = (e) => {
    e.preventDefault();
    if (inputPassword === GAME_PASSWORD) setIsAuthenticated(true);
    else { alert("Foutief wachtwoord!"); setInputPassword(''); }
  };

  const playSound = (type) => {
    if (!ENABLE_AUDIO) return;
    try {
      const audio = new Audio(type === 'positive' ? '/plus.mp3' : '/min.mp3');
      audio.volume = 0.5;
      audio.play().catch(() => {});
    } catch (e) {}
  };

  const triggerConfetti = () => {
    playSound('positive');
    confetti({ particleCount: 150, spread: 100, origin: { y: 0.6 } });
  };

  const updateGroupColor = (id, color) => setGroups(groups.map(g => g.id === id ? { ...g, color } : g));
  const updateGroupName = (id, name) => setGroups(groups.map(g => g.id === id ? { ...g, name } : g));
  const updateScore = (groupId, delta) => {
    if (delta > 0) playSound('positive');
    if (delta < 0) playSound('negative');
    setGroups(groups.map(g => g.id === groupId ? { ...g, scores: { ...g.scores, [currentRound]: (g.scores[currentRound] || 0) + delta } } : g));
  };
  const handleMassUpdate = (delta) => {
    if (delta > 0) playSound('positive');
    if (delta < 0) playSound('negative');
    setGroups(groups.map(g => ({ ...g, scores: { ...g.scores, [currentRound]: (g.scores[currentRound] || 0) + delta } })));
  };
  const handleManualInput = (groupId, value) => {
    const intValue = parseInt(value, 10) || 0;
    setGroups(groups.map(g => g.id === groupId ? { ...g, scores: { ...g.scores, [currentRound]: intValue } } : g));
  };
  
  // Functie die het input veld gebruikt om aantal teams te updaten
  const handleGroupCountChange = (e) => {
    const val = parseInt(e.target.value) || 1;
    const newCount = Math.max(1, Math.min(8, val)); 
    setNumGroups(newCount);

    if (groups.length !== newCount) {
       if (newCount > groups.length) {
          // Toevoegen
          const added = [];
          for(let i = groups.length; i < newCount; i++) {
             added.push({ id: i+1, name: `Groep ${i+1}`, color: DEMO_COLORS[i] || '#999', scores: {} });
          }
          setGroups([...groups, ...added]);
       } else {
          // Verwijderen
          setGroups(groups.slice(0, newCount));
       }
    }
  };

  const calculateTotal = (groupScores) => Object.values(groupScores).reduce((a, b) => a + b, 0);
  const sortGroups = () => { const sorted = [...groups].sort((a, b) => calculateTotal(b.scores) - calculateTotal(a.scores)); setGroups(sorted); };
  const sortOriginal = () => { const sorted = [...groups].sort((a, b) => a.id - b.id); setGroups(sorted); };
  
  const getStats = () => {
    const allTotals = groups.map(g => calculateTotal(g.scores));
    const grandTotal = allTotals.reduce((a, b) => a + b, 0);
    const average = allTotals.length ? grandTotal / allTotals.length : 0;
    return { grandTotal, average };
  };

  const handleResetGame = () => { if(window.confirm("Alles wissen?")) { localStorage.clear(); window.location.reload(); }};
  const toggleFullscreen = () => { if (!document.fullscreenElement) { document.documentElement.requestFullscreen().catch((e)=>{}); } else { if (document.exitFullscreen) document.exitFullscreen(); } };
  const exportCSV = () => { /* ... */ };

  const allTotalScores = groups.map(g => calculateTotal(g.scores));
  const highestScore = Math.max(...allTotalScores);
  const stats = getStats();

  if (isBlocked) return <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100vh',background:'#000',color:'red'}}>⛔ TOEGANG GEWEIGERD</div>;

  // LOGIN SCREEN
  if (!isAuthenticated) {
    return (
      <div className="app-container" data-theme="light">
        {SHOW_BG_IMAGE && <div className="bg-image-layer" style={{ opacity: 0.5 }}></div>}
        <div className="branding-container top-center"><div className="logo-top"></div></div>
        <div className="branding-container bottom-center"><div className="logo-bottom"></div></div>
        <div className="setup-screen">
          <form className="setup-card glass-panel" onSubmit={handleLogin} style={{maxWidth: '400px'}}>
            <h1>Welkom</h1>
            <div className="input-group" style={{marginBottom: '20px'}}>
              <input type="password" placeholder="Wachtwoord" value={inputPassword} onChange={(e) => setInputPassword(e.target.value)} style={{width: '100%', textAlign:'center'}} autoFocus />
            </div>
            <button type="submit" className="btn-primary" style={{width: '100%'}}>INLOGGEN</button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="app-container" data-theme={theme}>
      {SHOW_BG_IMAGE && <div className="bg-image-layer" style={{ opacity: bgImageOpacity }}></div>}

      <div className="branding-container top-center"><div className="logo-top"></div></div>
      <div className="branding-container bottom-center"><div className="logo-bottom"></div></div>

      {isPaused && (
        <div className="pause-overlay" onClick={() => setIsPaused(false)}>
           <div className="pause-image"></div>
        </div>
      )}

      {showRoulette && <RoulettePopup onClose={() => setShowRoulette(false)} />}

      {setupMode ? (
        <div className="setup-screen">
          <div className="setup-card glass-panel">
            <h1>Setup</h1>
            
            {/* Oude manier met invoerveld geactiveerd via ENABLE_FULL_SETUP */}
            {ENABLE_FULL_SETUP && (
              <div className="setup-controls-row" style={{justifyContent: 'center', marginBottom: '20px'}}>
                <div className="input-group">
                  <label>Aantal Groepen (1-8):</label>
                  <input 
                    type="number" 
                    min="1" 
                    max="8" 
                    value={numGroups} 
                    onChange={handleGroupCountChange} 
                    style={{textAlign:'center', fontSize:'1.2rem', padding:'10px'}}
                  />
                </div>
              </div>
            )}

            <div className="groups-preview">
              <div className="preview-grid">
                {groups.map(g => (
                  <div key={g.id} className="group-config-item">
                    {ENABLE_FULL_SETUP ? (
                      <input type="color" value={g.color} onChange={(e) => updateGroupColor(g.id, e.target.value)} />
                    ) : (
                      <div style={{width:'42px', height:'42px', background: g.color, borderRadius:'4px', border:'1px solid var(--text-muted)', flexShrink:0, boxShadow: '0 2px 5px rgba(0,0,0,0.1)'}} title="Kleur vast ingesteld" />
                    )}
                    <input type="text" value={g.name} onChange={(e) => updateGroupName(g.id, e.target.value)} placeholder="Groepsnaam" />
                  </div>
                ))}
              </div>
            </div>
            
            <div style={{display:'flex', gap:'20px', marginTop:'20px'}}>
               <button className="btn-primary" onClick={() => setSetupMode(false)}>START GAME</button>
               {ENABLE_AUTOSAVE && <button className="btn-danger" onClick={handleResetGame}><TrashIcon /> RESET</button>}
            </div>
          </div>
        </div>
      ) : (
        <div className="game-screen">
          <header className="game-header glass-panel">
            <div className="header-left">
              <button className="btn-icon" onClick={() => setSetupMode(true)} title="Instellingen"><SettingsIcon /></button>
              
              <div className="round-selector">
                <label>Ronde:</label>
                <select value={currentRound} onChange={(e) => setCurrentRound(parseInt(e.target.value))}>
                  {Array.from({ length: TOTAL_ROUNDS }, (_, i) => <option key={i+1} value={i+1}>{i+1}</option>)}
                </select>
              </div>
            </div>
            
            {ENABLE_GAME_TOOLS && (
              <div className="header-center">
                <div className="mass-group">
                  <button className="btn-ghost positive" onClick={() => handleMassUpdate(20)}><ThumbUpIcon /> +20</button>
                  <button className="btn-ghost positive" onClick={() => handleMassUpdate(50)}><ThumbUpIcon /> +50</button>
                </div>
                <div className="mass-group">
                  <button className="btn-ghost negative" onClick={() => handleMassUpdate(-20)}><ThumbDownIcon /> -20</button>
                  <button className="btn-ghost negative" onClick={() => handleMassUpdate(-50)}><ThumbDownIcon /> -50</button>
                </div>
              </div>
            )}
            
            <div className="header-actions">
               <button className="btn-icon" onClick={() => setShowRoulette(true)} title="Open Roulette"><RouletteIcon /></button>

               {ENABLE_GAME_TOOLS && (
                 <>
                   <div className="stats-box"><small>Totaal: {formatCurrency(stats.grandTotal)}</small></div>
                   <button className="btn-icon" onClick={sortGroups} title="Sorteer"><SortIcon /></button>
                   <button className="btn-icon" onClick={sortOriginal} title="Lijst"><ListIcon /></button>
                   
                   <label className="theme-toggle">
                      <input type="checkbox" checked={theme === 'dark'} onChange={() => setTheme(theme === 'light' ? 'dark' : 'light')} />
                      <span className="toggle-slider">
                        <svg className="icon-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>
                        <svg className="icon-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>
                        <span className="toggle-knob"></span>
                      </span>
                   </label>
                 </>
               )}
               
               {ENABLE_PAUSE && <button className="btn-icon" onClick={() => setIsPaused(true)} title="Pauze"><PauseIcon /></button>}
               {ENABLE_CONFETTI && <button className="btn-icon" onClick={triggerConfetti} title="Confetti!"><PartyIcon /></button>}
               {ENABLE_GAME_TOOLS && (
                 <>
                   <button className="btn-icon" onClick={toggleFullscreen} title="Volledig Scherm"><FullscreenIcon /></button>
                   <button className="btn-icon" onClick={exportCSV} title="Export CSV"><DownloadIcon /></button>
                 </>
               )}
            </div>
          </header>

          <main className="groups-grid">
            {groups.map(group => {
                const roundScore = group.scores[currentRound] || 0;
                const totalScore = calculateTotal(group.scores);
                const isLeader = totalScore > 0 && totalScore === highestScore && ENABLE_GAME_TOOLS;

                return (
                  <div key={group.id} className="group-card glass-panel" style={{ borderTop: `6px solid ${group.color}` }}>
                    <div className="group-info">
                      <div className="name-input-wrapper">
                         <input className="group-name-input" value={group.name} onChange={(e) => updateGroupName(group.id, e.target.value)} style={{ color: group.color }} />
                         {isLeader && <RocketIcon />}
                      </div>
                    </div>
                    <div className="score-display">
                      <div className="round-score"><span>Ronde {currentRound}</span><strong>{formatCurrency(roundScore)}</strong></div>
                      <div className="total-score"><span>Totaal</span><strong>{formatCurrency(totalScore)}</strong></div>
                    </div>
                    <div className="controls">
                      <div className="btn-row">
                        <button className="btn-ghost positive" onClick={() => updateScore(group.id, 20)}>+20</button>
                        <button className="btn-ghost positive" onClick={() => updateScore(group.id, 50)}>+50</button>
                        <button className="btn-ghost positive btn-s" onClick={() => updateScore(group.id, 100)}>+100</button>
                      </div>
                      <input type="number" className="manual-input" value={roundScore} onChange={(e) => handleManualInput(group.id, e.target.value)} />
                      <div className="btn-row">
                        <button className="btn-ghost negative btn-s" onClick={() => updateScore(group.id, -100)}>-100</button>
                        <button className="btn-ghost negative" onClick={() => updateScore(group.id, -50)}>-50</button>
                        <button className="btn-ghost negative" onClick={() => updateScore(group.id, -20)}>-20</button>
                      </div>
                    </div>
                  </div>
                );
            })}
          </main>
        </div>
      )}
    </div>
  );
}

export default App;